import { useCallback, useState } from "react";

import * as ModelConverter from "@/components/features/_model/converter";

import * as Factory from "./factory";
import * as FormModelType from "./type";
import * as ValidationSchema from "./validation-schema";

const defaultInputModel = Factory.Default.setupInputModelFactory();

export const useSetupFormModel = (initInputModel: FormModelType.SetupFormModel["InputModel"]) => {
	// InputModel の初期化
	const [currentInputModel, setCurrentInputModel] =
		useState<FormModelType.SetupFormModel["InputModel"]>(initInputModel);

	// ViewModel の初期化
	const [viewModel, setViewModel] = useState<FormModelType.SetupFormModel["ViewModel"]>(
		ModelConverter.inputModelToViewModelConverter<
			FormModelType.SetupFormModel["InputModel"],
			FormModelType.ExcludeKeys,
			FormModelType.SetupFormModel["QueryData"],
			ValidationSchema.SetupInputZodSchemaType
		>({
			defaultInput: defaultInputModel,
			initInput: initInputModel,
			currentInput: initInputModel,
			excludeKeys: FormModelType.excludeKeys,
			zodSchema: ValidationSchema.SetupInputZodSchema,
		}),
	);

	// ViewModel の更新
	const onSetViewModel = useCallback(
		(_viewModel: FormModelType.SetupFormModel["ViewModel"]) => {
			const convertedInputModel = ModelConverter.viewModelToInputModelConverter(_viewModel);
			const convertedViewModel = ModelConverter.inputModelToViewModelConverter<
				FormModelType.SetupFormModel["InputModel"],
				FormModelType.ExcludeKeys,
				FormModelType.SetupFormModel["QueryData"],
				ValidationSchema.SetupInputZodSchemaType
			>({
				defaultInput: defaultInputModel,
				initInput: initInputModel,
				currentInput: convertedInputModel,
				excludeKeys: FormModelType.excludeKeys,
				zodSchema: ValidationSchema.SetupInputZodSchema,
			});
			// state の更新
			setCurrentInputModel(convertedInputModel);
			setViewModel(convertedViewModel);
		},
		[initInputModel],
	);

	return {
		inputModel: currentInputModel,
		viewModel,
		onSetViewModel,
	};
};
